import { BreadcrumbsItem, BreadcrumbsMetadata } from "./breadcrumbs.types";

export const getBreadcrumbs = (meta: BreadcrumbsMetadata) => {
  const capitalizeFirstLetter = (string: string) => {
    const words = string.split(" ");

    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    );
    return capitalizedWords.join(" ");
  };

  const replaceContent = (meta: BreadcrumbsMetadata, content: string) => {
    let res = content;

    if (meta.mspName) {
      res = res.replace(/^Msp$/, meta.mspName);
    }
    if (meta.customerName) {
      res = res.replace(/^Customer$/, meta.customerName);
    }
    return res;
  };

  const pathToArray = `${meta.parentPath}${meta.routePath}`.split("/");
  return pathToArray
    .map((item) => replaceContent(meta, capitalizeFirstLetter(item)))
    .reduce<BreadcrumbsItem[]>((acc, cur, idx) => {
      if (idx === 0) return [];

      const link = pathToArray[idx];
      const getUrl = () => {
        if (idx === 1) {
          return `/${link}`;
        }
        if (pathToArray.length === idx + 1) {
          return "";
        }
        return `${acc[idx - 2].url}/${link}`;
      };

      const breadcrumbs = [
        ...acc,
        {
          name: /^\d+$/.test(cur)
            ? meta.title
            : capitalizeFirstLetter(
                cur.replace(/[_ -]/g, " ").replace(/%20/g, " "),
              ),
          url: getUrl(),
        },
      ];
      return breadcrumbs;
    }, []);
};
